import React from 'react';
import { Form, Button } from 'react-bootstrap';

const ForgotPasswordFormFields = ({
  email,
  setEmail,
  otpSent,
  otpVerified,
  otp,
  setOtp,
  password,
  setPassword,
  loading,
  handleVerifyOtp,
  handleResetPassword
}) => {
  return (
    <>
      <Form.Group className="mb-4" controlId="forgotEmail">
        <Form.Control
          type="email"
          placeholder="Email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
          className="form-ctrl-login-custom"
        />
      </Form.Group>

      {!otpSent && (
        <Button
          variant="outline-dark"
          type="submit"
          className="w-100 btn-lg text-uppercase"
          disabled={loading}
          style={{
            color: "#fff",
            borderColor: "#495057",
            background: "linear-gradient(135deg, #c30000 0%, #b33a3a 100%)"
          }}
        >
          {loading ? 'Sending...' : 'Get a new password'}
        </Button>
      )}

      {otpSent && !otpVerified && (
        <>
          <Form.Group className="mt-3">
            <Form.Control
              type="text"
              placeholder="Enter OTP"
              value={otp}
              onChange={(e) => setOtp(e.target.value)}
            />
          </Form.Group>

          <Button
            className="btn-auth-primary w-100 mt-3"
            type="button"
            onClick={handleVerifyOtp}
          >
            Verify OTP
          </Button>
        </>
      )}

      {otpVerified && (
        <>
          <Form.Group className="mt-3">
            <Form.Control
              type="password"
              placeholder="New Password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
          </Form.Group>

          <Button
            type="button"
            className="btn-auth-primary w-100 mt-3"
            onClick={handleResetPassword}
          >
            Reset Password
          </Button>
        </>
      )}
    </>
  );
};

export default ForgotPasswordFormFields;
